export const ADD_AA_FAMILY_MEMBER_MODAL_NAME =
  'ADD_AA_FAMILY_MEMBER_MODAL_NAME';
